import React,{useEffect,useRef,useState} from 'react'
import { GlobalDataState } from '../../../Context';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {FiArrowRight,FiArrowLeft} from "react-icons/fi"

import './Popular.css';

const Popular = () => {
    const [popularData,setpopularData]=useState({});
    const [width,setWidth]=useState(0);
    
    const carousel=useRef()


    // useEffect(()=>{
    //    setWidth(carousel.current.scrollWidth-carousel.current.offsetWidth);
    // },[])
    const {
        state:{stack},
        dispatch,
    }=GlobalDataState();

    const{setClickedId,setAllData,allData}=GlobalDataState();
    useEffect(()=>{
       getTrending();
    },[]);
    
    async function getTrending(){
        const data=await fetch(`https://api.themoviedb.org/3/movie/popular?api_key=95827c3fee6b7922a023ac65e529dca2&language=en-US&page=1`)
        const json=await data.json();
        // console.log(json);
        setpopularData(json?.results);
      

    }

    
    
    function handlesetId(idx){
       setClickedId(idx);
    }
    
    let box = document.querySelector('.Pitems');

    const btnpressprev = () => {
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft - width;
        console.log(width)
    }

    const btnpressnext = () => {
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft + width;
        console.log(width)
    }
    
  return (
    <div>
    <h1>POPULAR</h1>
    <div className='Pitems'>
     <h1></h1>
    <button className="Ppre-btn" onClick={btnpressprev}><p>&lt;</p></button>
    <button className="Pnext-btn" onClick={btnpressnext}><p>&gt;</p></button>
        {
           
          popularData &&  Object.values(popularData).map((item)=>(
                <div className='itemox'>
                    
                <Link to={"/moviesdetails"} style={{textDecoration:'none',color:'inherit'}}>
                <div  onClick={()=>handlesetId(item.id)}>
                <img className='img' src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}></img>
                <a>{item.vote_average}</a>
                <div className='name' style={{wordWrap:'wordBreak',overflow:"hidden"}}>
                    {
                        item.title? <span style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.title}</span>:<span style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"15rem",width:"auto",fontWeight:"bold"}}>{item.name}</span>
                    }
                </div>
                {/* <div>{item.release_date?item.release_date:<h5>upcoming</h5>}</div> */}
                </div>
                </Link>
                <div>
                    
                <button onClick={()=>dispatch({type:"ADD_TO_STORE",payload:item,})} style={{borderRadius:"1rem",backgroundColor:"#16FF00"}}>ADD</button>
                <button onClick={()=>dispatch({type:"REMOVE_FROM_STORE",payload:item,})} style={{borderRadius:"1rem",backgroundColor:"#FF0303"}}>REMOVE</button>
                </div>     
                </div>    
            ))
           
        }
       
        
        </div>
        
    </div>
  )
}

export default Popular